import { styled } from '@mui/material/styles'

export const menuInputStyle = styled('div')(({ theme }) => ({
  control: {
    lineHeight: '18px',
    fontWeight: 'normal',
  },
  '&multiLine': {
    control: {
      minHeight: 63,
    },
    highlighter: {
      padding: 9,
      border: '1px solid transparent',
    },
    input: {
      padding: 9,
      border: 'none',
      outline: 'none',
    },
  },
  suggestions: {
    list: {
      backgroundColor: 'white',
      border: '1px solid rgba(0,0,0,0.15)',
      fontSize: 14,
    },
    item: {
      padding: '5px 15px',
      borderBottom: '1px solid rgba(0,0,0,0.15)',
      '&focused': {
        backgroundColor: theme.palette.grey[50],
      },
    },
  },
}))

export const mentionStyle = styled('div')(({ theme }) => ({
  color: theme.palette.primary.main,
}))
